import type { AppRouter } from "@senciamatch/backend/routers";
import { createTRPCReact } from "@trpc/react-query";

export const trpc = createTRPCReact<AppRouter>();
